module.exports = __webpack_public_path__ + "static/media/Muhammad_Usman_Resume.5b7127ff.pdf";